// ----------------------------------------------------------------------

export const paths = {
  // Brand select
  brandSelect: '/',
  // Home
  home: '/home',
  // Login
  login: '/login',
  // Popup
  popup: '/popup',
  // Auth
  auth: {
    root: '/auth',
    dormancy: '/auth/dormancy',
    emailVerfication: {
      root: '/auth/email-verification',
      resend: '/auth/email-verification/resend',
    },
    termsAgree: '/auth/terms-agree',
    verificationcode: '/auth/verification-code',
    storetransfer: '/auth/storetransfer',
  },
  // Member
  member: {
    root: '/member',
    password: {
      passwordChange: '/member/password/change', // NOSONAR route string
      reissueChangePassword: '/member/password/re-issue', // NOSONAR route string
    },
  },
  // Join
  join: {
    root: '/join',
    intro: '/join/intro',
    policy: {
      root: '/join/policy',
      terms: '/join/policy/terms',
      privacy: '/join/policy/privacy',
    },
    brand: '/join/brand',
    brandSearch: '/join/brand-search',
    codeInput: '/join/code-input',
    responsibility: '/join/responsibility',
    code: '/join/code',
    name: '/join/name',
    email: '/join/email',
    password: '/join/password', // NOSONAR route string
    repassword: '/join/re-password', // NOSONAR route string
    store: '/join/store',
    complete: {
      root: '/join/complete',
      approved: '/join/complete/approved',
      unapproved: '/join/complete/unapproved',
    },
    existSocial: '/join/exist-social',
    socialInput: '/join/social-input',
  },
  // Telegram
  telegram: {
    root: '/telegram',
    message: '/telegram/message',
  },
  // Find
  find: {
    root: '/find',
    password: {
      root: '/find/password',
      code: '/find/password/code',
      verify: '/find/password/verify',
      password: '/find/password/password', // NOSONAR route string
      rePassword: '/find/password/re-password',
      complete: '/find/password/complete',
    },
    code: '/find/code',
    id: {
      root: '/find/id',
      name: '/find/id/name',
      code: '/find/id/code',
      verify: '/find/id/verify',
      complete: '/find/id/complete',
    },
  },
  // Leader Board
  learderBoard: {
    root: '/leader-board?status=RANKING',
    storeRanking: '/leader-board?status=STORE',
  },
  // My Class:
  myClass: {
    root: '/learn',
    learning: '/learn?status=LEARNING',
    waiting: '/learn?status=WAITING',
    complete: '/learn?status=COMPLETION',
    detail: (id: string) => `/learn/${id}`,
    learningContent: (learnId: string, lessonId: string, progressionId: string) =>
      `/learn/${learnId}/lesson/${lessonId}/progression/${progressionId}`,
    lessonChatroom: (learnId: string, lessonId: string, roomId: string) =>
      `/learn/${learnId}/lesson/${lessonId}/chatroom/${roomId}/chat`,
    mission: (learnId: string, assignmentId: string) =>
      `/learn/${learnId}/mission/assignment/${assignmentId}`,
    missionSubmit: (learnId: string, assignmentId: string) =>
      `/learn/${learnId}/mission/assignment/${assignmentId}/submit`,
    missionView: (learnId: string, assignmentId: string) =>
      `/learn/${learnId}/mission/assignment/${assignmentId}/view`,
    missionAnswer: (learnId: string, assignmentId: string, answerId: string) =>
      `/learn/${learnId}/mission/assignment/${assignmentId}/answer/${answerId}`,
    examIntro: (learnId: string, examineeId: string) =>
      `/learn/${learnId}/examinee/${examineeId}/intro`,
    examTake: (learnId: string, examineeId: string) =>
      `/learn/${learnId}/examinee/${examineeId}/take`,
    examResult: (learnId: string, examineeId: string) =>
      `/learn/${learnId}/examinee/${examineeId}/result`,
    examFeedback: (learnId: string, examineeId: string, paperId: string) =>
      `/learn/${learnId}/examinee/${examineeId}/paper/${paperId}/feedback`,
    examFeedbackIssue: (learnId: string, examineeId: string, paperId: string, questionId: string) =>
      `/learn/${learnId}/examinee/${examineeId}/paper/${paperId}/feedback/question/${questionId}/issue`,
    examFeedbackList: (learnId: string, examineeId: string, paperId: string, questionId: string) =>
      `/learn/${learnId}/examinee/${examineeId}/paper/${paperId}/feedback/question/${questionId}`,
  },
  // Deeplink
  deeplink: '/deeplink',
  // Degree
  degree: {
    root: '/degree?listType=ListTotal',
    popular: '/degree?listType=ListPopular',
    new: '/degree?listType=ListNew',
    recommended: '/degree?listType=ListRecommended',
    detail: (id: string) => `/degree/${id}`,
  },
  // Exam
  exam: {
    root: '/exam',
    myTest: '/exam/my',
    independentDetail: (id: string) => `/exam/distribution/${id}`,
    resultRoot: (id: string) => `/exam/examinee/${id}/result?listType=result`,
    resultTake: (id: string) => `/exam/examinee/${id}/result/take`,
    resultDetail: (id: string) => `/exam/examinee/${id}/result/detail`,
    feedbackRoot: (id: string, paperId: string) =>
      `/exam/examinee/${id}/result/paper/${paperId}/feedback`,
    feedbackIssue: (id: string, paperId: string, questionId: string) =>
      `/exam/examinee/${id}/result/paper/${paperId}/feedback/question/${questionId}/issue`,
    feedbackList: (id: string, paperId: string, questionId: string) =>
      `/exam/examinee/${id}/result/paper/${paperId}/feedback/question/${questionId}`,
    examFeedbackListChatRoom: (id: string, paperId: string, questionId: string, roomId: string) =>
      `/exam/examinee/${id}/result/paper/${paperId}/feedback/question/${questionId}/chatroom/${roomId}/chat`,
    take: (id: string) => `/exam/examinee/${id}/my/take`,
    detail: (id: string) => `/exam/examinee/${id}/my`,
    intro: (id: string) => `/exam/examinee/${id}/my/intro`,
  },
  // Survey
  survey: {
    root: '/survey?listType=total',
    detail: (id: number) => `/survey/distribution/${id}`,

    insightRoot: '/survey?listType=result',
    insightDetail: (id: number) => `/survey/distribution/${id}/insight`,
    result: (id: number, respondentId: number) =>
      `/survey/distribution/${id}/respondent/${respondentId}/result`,
    take: (id: number, respondentId: number) =>
      `/survey/distribution/${id}/respondent/${respondentId}/take`,
    feedback: (id: number, respondentId: number) =>
      `/survey/distribution/${id}/respondent/${respondentId}/feedback`,
    intro: (id: number, respondentId: number) =>
      `/survey/distribution/${id}/respondent/${respondentId}/intro`,
  },
  // Reward
  reward: {
    root: '/reward',
    point: '/reward/point',
    level: '/reward/level',
  },
  // My Portfolio
  portfolio: {
    root: '/portfolio',
    bookmarkedLesson: '/portfolio/bookmarked-lesson',
    bookmarkedMission: '/portfolio/bookmarked-mission',
    likedLesson: '/portfolio/liked-lesson',
    socialLesson: '/portfolio/social-lesson',
    questionIssue: {
      root: '/portfolio/report-issue',
      detail: (id: string) => `/portfolio/report-issue/${id}`,
    },
    likedInstantLearning: {
      root: '/portfolio/liked-instant-learning',
    },
    examQuestion: {
      root: '/portfolio/exam-question',
      detail: (id: string) => `/portfolio/exam-question/${id}`,
    },
    lessonQuestion: {
      root: '/portfolio/lesson-question',
      detail: (id: string) => `/portfolio/lesson-question/${id}`,
    },
    certificate: {
      root: '/portfolio/certificate',
      detail: (id: any) => `/portfolio/certificate/${id}`,
    },

    badge: '/portfolio/badge',
    myBadge: (id: string) => `/portfolio/badge/${id}`,
    availableBadge: (id: string) => `/portfolio/badge/${id}/available`,
  },
  // Social Learning
  socialLearning: {
    root: (boardIdentifier?: string) => `/social-learning/${boardIdentifier}`,
    detail: (boardIdentifier: string, articleId: string) =>
      `/social-learning/${boardIdentifier}/article/${articleId}`,
    write: (boardIdentifier: string) => `/social-learning/${boardIdentifier}/article`,
    edit: (boardIdentifier: string, articleId: string) =>
      `/social-learning/${boardIdentifier}/article/${articleId}/edit`,
    myPost: `/social-learning/mypost`,
  },
  // Community
  community: {
    root: '/community/',
    list: (boardId: string) => `/community/${boardId}`,
    create: (boardId: string) => `/community/${boardId}/article`,
    edit: (boardId: string, articleId: string) => `/community/${boardId}/article/${articleId}/edit`,
    view: (boardId: string, articleId: string) => `/community/${boardId}/article/${articleId}`,
  },
  // Store
  store: {
    root: '/inventory',
    detail: (id: number) => `/inventory/goods/${id}`,
    modify: (id: number) => `/inventory/goods/${id}/modify`,
    create: (id: number) => `/inventory/goods/${id}/create`,
    search: '/inventory/goods/search',
    barcode: '/inventory/goods/barcode',
  },
  // Check List
  checklist: {
    root: '/checklist',
    detail: (id: string) => `/checklist/respondent/${id}`,
    submittedResult: (id: string) => `/checklist/respondent/${id}/result`,
    take: (id: string) => `/checklist/respondent/${id}/take`,
  },

  // Purchase
  purchase: {
    root: '/purchase',
    refund: '/purchase/refund',
  },
  // My information
  myInformation: {
    root: '/myinfo',
    modify: '/myinfo/modify',
    resetPassword: '/myinfo/reset-password',
    code: '/myinfo/reset-password/code',
    newPassword: '/myinfo/reset-password/new-password',
    reNewPassword: '/myinfo/reset-password/re-new-password',
    complete: '/myinfo/reset-password/complete',

    password: {
      passwordChange: '/myinfo/password/change', // NOSONAR route string
      reissueChangePassword: '/myinfo/password/re-issue',
    },
    myProfile: '/myinfo/profile',
    pattern: '/myinfo/profile/pattern',
    picture: '/myinfo/profile/picture',
    camera: '/myinfo/profile/camera',
    license: '/license',
    licenseModify: '/license/modify',
    licenseCreate: '/license/create',
    licenseView: '/license/view',
    serviceWithdrawral: '/myinfo/withdraw',
    withdrawConfirm: '/myinfo/withdraw/confirm',
    withdrawReason: '/myinfo/withdraw/reason',
    termsManagement: '/myinfo/terms-management',
    termsOfSerivce: '/myinfo/terms-management/terms-of-service',
    privacyPolicy: '/myinfo/terms-management/privacy-policy',
    blockUser: '/myinfo/block-user',
    setting: '/myinfo/setting',
    languages: '/myinfo/setting/languages',
  },

  // License
  license: {
    root: '/license',
    viewLicense: '/license/view',
    createLicense: '/license/create',
  },
  // inbox
  inbox: {
    root: '/inbox',
  },

  setting: {
    root: '/setting',
    privacy: '/setting/privacy',
    terms: '/setting/terms',
    languages: '/setting/languages',
  },
  instantLearning: {
    root: '/instant-learning',
    detail: (id: string) => `/instant-learning/${id}`,
  },
  // Marketing
  marketing: {
    root: '/marketing',
    services: '/marketing/services',
    caseStudies: '/marketing/case-studies',
    caseStudy: `/marketing/case-study`,
    posts: '/marketing/posts',
    post: `/marketing/post`,
    about: '/marketing/about',
    contact: '/marketing/contact',
  },
  // Sales
  sales: {
    root: '/sales',
    duplicate: (id: string) => `/sales/goods/${id}/duplicate`,
    information: (id: string) => `/sales/goods/${id}/information`,
    cart: (id: string) => `/sales/goods/${id}/cart`,
    resultEnroll: (id: string) => `/sales/order/${id}/result/enroll`,
  },

  // Travel
  travel: {
    root: '/travel',
    tours: '/travel/tours',
    tour: `/travel/tour`,
    checkout: '/travel/checkout',
    orderCompleted: '/travel/order-completed',
    posts: '/travel/posts',
    post: `/travel/post`,
    about: '/travel/about',
    contact: '/travel/contact',
  },
  // Career
  career: {
    root: '/career',
    jobs: '/career/jobs',
    job: `/career/job`,
    posts: '/career/posts',
    post: `/career/post`,
    about: '/career/about',
    contact: '/career/contact',
  },
  // E-learning
  eLearning: {
    root: '/e-learning',
    courses: '/e-learning/courses',
    course: `/e-learning/course`,
    posts: '/e-learning/posts',
    post: `/e-learning/post`,
    about: '/e-learning/about',
    contact: '/e-learning/contact',
  },
  // E-commerce
  eCommerce: {
    root: '/e-commerce',
    products: '/e-commerce/products',
    product: `/e-commerce/product`,
    cart: '/e-commerce/cart',
    checkout: `/e-commerce/checkout`,
    orderCompleted: '/e-commerce/order-completed',
    wishlist: `/e-commerce/wishlist`,
    compare: `/e-commerce/compare`,
    account: {
      root: `/e-commerce/account`,
      personal: `/e-commerce/account/personal`,
      wishlist: `/e-commerce/account/wishlist`,
      vouchers: `/e-commerce/account/vouchers`,
      orders: `/e-commerce/account/orders`,
      payment: `/e-commerce/account/payment`,
    },
  },
  // Auth
  loginCover: '/auth/login-cover',
  loginBackground: '/auth/login-background',
  loginIllustration: '/auth/login-illustration',
  registerCover: '/auth/register-cover',
  registerBackground: '/auth/register-background',
  registerIllustration: '/auth/register-illustration',
  forgotPassword: '/auth/forgot-password',
  verify: '/auth/verify',
  // Common
  maintenance: '/maintenance',
  comingsoon: '/coming-soon',
  pricing01: '/pricing-01',
  pricing02: '/pricing-02',
  payment: '/payment',
  support: '/support',
  page404: '/404',
  page500: '/error',
  // Components
  components: {
    root: '/components',
    animate: '/components/animate',
    carousel: '/components/carousel',
    countUp: '/components/count-up',
    form: '/components/form-validation',
    icons: '/components/icons',
    image: '/components/image',
    label: '/components/label',
    lightbox: '/components/lightbox',
    markdown: '/components/markdown',
    megaMenu: '/components/mega-menu',
    navigation: '/components/navigation-bar',
    scroll: '/components/scroll',
    scrollProgress: '/components/scroll-progress',
    player: '/components/player',
    textMaxLine: '/components/text-max-line',
  },
  // Others
  pages: '/pages',
  docs: 'https://zone-docs.vercel.app',
  muiLicense: 'https://material-ui.com/store/license/#i-standard-license',
  minimalStore: 'https://material-ui.com/store/items/minimal-dashboard',
  zoneStore: 'https://mui.com/store/items/zone-landing-page/',
  figmaPreview:
    'https://www.figma.com/file/Zam9QBLhV4pZf5xtNs0Lf8/%5BPreview%5D-Zone_Web.v2.3.0?type=design&node-id=59%3A680507&mode=design&t=GCVeJci5zfUu5WCy-1',
};
